"use client";

import {LoadingOverlay} from "@/components/table/neo-table/loaderNggrid";
import {routePlanService} from "@/service/routePlan.service";
import {createContext, ReactNode, useContext, useEffect, useState} from "react";

type RoutePlanContextType = {
  planId: string | number;
  routePlanItem: RoutePlan | null;
  setCurrentVariant: React.Dispatch<React.SetStateAction<number | null>>;
  currentVariant: number | null;
  fetchRoutePlanData: () => Promise<void>;
};
const RoutePlanContext = createContext<RoutePlanContextType | null>(null);

export function RoutePlanProvider({
  planId,
  children
}: {
  planId: number | string;
  children: ReactNode;
}) {
  const [routePlanItem, setRoutePlanItem] = useState<RoutePlan | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentVariant, setCurrentVariant] = useState<null | number>(null);
  const fetchRoutePlanData = async () => {
    setLoading(true);
    await routePlanService
      .getRoutePlans()
      .then((response: RoutePlan[]) => {
        // console.log(response);
        // Get actual plan by planId
        const CurrentPlan: RoutePlan | null =
          response.find((item: RoutePlan) => item.planId == planId) || null;
        //console.log("CurrentPlan", CurrentPlan);
        if (CurrentPlan) {
          //Set current variant
          setCurrentVariant(CurrentPlan.variantId || null);
        }
        setRoutePlanItem(CurrentPlan);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchRoutePlanData();
  }, []);
  return (
    <RoutePlanContext.Provider
      value={{
        planId,
        routePlanItem,
        setCurrentVariant,
        currentVariant,
        fetchRoutePlanData
      }}
    >
      {loading ? <LoadingOverlay /> : children}
    </RoutePlanContext.Provider>
  );
}

export function useRoutePlan() {
  const ctx = useContext(RoutePlanContext);
  if (!ctx)
    throw new Error("useRoutePlan must be used within RoutePlanProvider");
  return ctx;
}
